import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FaBars, FaTimes } from "react-icons/fa"; // Icons for menu
import '@fortawesome/fontawesome-free/css/all.min.css'; // Font Awesome import
import NavbarLink from "./NavbarLink"; // Custom component for links
import orgatroit from "../Db/orgatroit.png";

const Navbar = () => {
  const [open, setOpen] = useState(false);

  const menuLinks = [
    { name: "Home", path: "/", icon: "fa-home" },
    { name: "About", path: "/about-us", icon: "fa-info-circle" },
    { name: "Pricing", path: "/pricing", icon: "fa-dollar-sign" },
    { name: "Work", path: "/work", icon: "fa-briefcase" },
    { name: "Blog", path: "/blog", icon: "fa-file-alt" },
  ];

  return (
    <nav className="bg-white shadow-md sticky top-0 z-50">
      <div className="flex items-center justify-between p-2 md:justify-around">
        
        {/* Logo Section */}
        <div className="flex items-center justify-between w-full md:w-auto">
          <Link to="/">
            <img src={orgatroit} alt="orgatroit logo" className="logo-image"></img>
          </Link>
          {/* Mobile Menu Icon */}
          <div
            className="text-3xl md:hidden cursor-pointer"
            onClick={() => setOpen(!open)}
            aria-label={open ? "Close menu" : "Open menu"}
          >
            {open ? <FaTimes /> : <FaBars />}
          </div>
        </div>

        {/* Desktop Links */}
        <ul className="hidden md:flex items-center space-x-6 font-medium uppercase">
          {menuLinks.map((link) => (
            <li key={link.name}>
              <Link to={link.path} className="py-2 px- hover:text-primary hover:underline">
                <span className="mr-2">
                  <i className={`fas ${link.icon}`}></i>
                </span>
                {link.name}
              </Link>
            </li>
          ))}
          <NavbarLink />
        </ul>

        {/* Call-to-Action Button */}
        <div className="hidden md:flex xl:flex">
          <Link
            to="/contact-us"
            className="px-6 py-2 bg-green-500 text-white rounded-full hover:bg-opacity-80 transition duration-300"
          >
            <span className="mr-2">
              <i className="fa-solid fa-envelope-circle-check"></i>
            </span>
            Contact Us
          </Link>
        </div>

        {/* Mobile Menu */}
        <ul
          className={`md:hidden fixed top-0 left-0 w-full h-screen bg-white p-10 pt-24 space-y-5 transition-all duration-300 ${
            open ? "translate-x-0" : "-translate-x-full"
          }`}
        >
          {menuLinks.map((link) => (
            <li key={link.name}>
              <Link
                to={link.path}
                className="block text-xl py-2 px-4 hover:text-primary"
                onClick={() => setOpen(false)}
              >
                <span className="mr-2">
                  <i className={`fas ${link.icon}`}></i>
                
                </span>
                {link.name}
              </Link>
            </li>
          ))}
          {/* CTA Button for Mobile */}
          <li>
            <Link
              to="/contact-us"
              className="block w-full text-center bg-green-500 text-white py-2 rounded-md hover:bg-opacity-80"
              onClick={() => setOpen(false)}
            >
              <span className="mr-2">
                <i className="fa-solid fa-envelope-circle-check"></i> Contact Us
              </span>
            </Link>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
